<template>
<div>
  <div class="row">
    <div class="col-lg-2 col-sm-6">
      <stats-card v-loading="isLoadingEventsCount">
        <div
          class="icon-big text-center"
          :class="'icon-success'"
          slot="header"
        >
          <i class="ti-location-pin"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ eventsCount.length }}
          <p>{{config.hasOwnProperty('eventLabel') ? config.eventLabel : 'Eventos'}}</p>
        </div>
        <!-- <div class="stats" slot="footer"><i :class="stats.footerIcon"></i> {{stats.footerText}}</div> -->
      </stats-card>
    </div>
    <div class="col-lg-2 col-sm-6">
      <stats-card v-loading="isLoadingCustomersCount">
        <div
          class="icon-big text-center"
          :class="'icon-warning'"
          slot="header"
        >
          <i class="ti-user"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ participantsCount }}
          <p>Participantes</p>
        </div>
        <!-- <div class="stats" slot="footer"><i :class="stats.footerIcon"></i> {{stats.footerText}}</div> -->
      </stats-card>
    </div>
    <div class="col-lg-2 col-sm-6">
      <stats-card v-loading="isLoadingTicketsCount">
        <div
          class="icon-big text-center"
          :class="'icon-default'"
          slot="header"
        >
          <i class="ti-ticket"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ ticketsCount }}
          <p>Tickets</p>
        </div>
      </stats-card>
    </div>
    <div class="col-lg-2 col-sm-6">
      <stats-card v-loading="isLoadingWinnersCount">
        <div
          class="icon-big text-center"
          :class="'icon-danger'"
          slot="header"
        >
          <i class="ti-layout-media-overlay-alt-2"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ winnersCount }}
          <p>Geladeiras</p>
        </div>
        <!-- <div class="stats" slot="footer"><i :class="stats.footerIcon"></i> {{stats.footerText}}</div> -->
      </stats-card>
    </div>
    <div class="col-lg-2 col-sm-6">
      <stats-card v-loading="isLoadingLampsCount">
        <div
          class="icon-big text-center"
          :class="'icon-info'"
          slot="header"
        >
          <i class="ti-light-bulb"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ lampsCount }}
          <p>Lâmpadas</p>
        </div>
        <!-- <div class="stats" slot="footer"><i :class="stats.footerIcon"></i> {{stats.footerText}}</div> -->
      </stats-card>
    </div>
    <div
      v-if="this.config.haveSurveys"
      class="col-lg-2 col-sm-6"
    >
      <stats-card v-loading="loadingSurveys">
        <div
          class="icon-big text-center"
          :class="'icon-info'"
          slot="header"
        >
          <i class="ti-notepad"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ surveysFinishedCount }}
          <p>Pesquisas</p>
        </div>
        <!-- <div class="stats" slot="footer"><i :class="stats.footerIcon"></i> {{stats.footerText}}</div> -->
      </stats-card>
    </div>
  </div>
  <div
    class="row"
    v-if="projectOnline && config.dashboardEduCards"
  >
    <div class="col-lg-2 col-sm-6">
      <stats-card v-loading="edu.loading">
        <div
          class="icon-big text-center"
          :class="'icon-info'"
          slot="header"
        >
          <p>Educacional</p>
          <i class="ti-location-pin"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ edu.eventsCount }}
          <p>Eventos</p>
        </div>
        <!-- <div class="stats" slot="footer"><i :class="stats.footerIcon"></i> {{stats.footerText}}</div> -->
      </stats-card>
    </div>
    <div class="col-lg-2 col-sm-6">
      <stats-card v-loading="edu.loading">
        <div
          class="icon-big text-center"
          :class="'icon-info'"
          slot="header"
        >
          <p>Educacional</p>
          <i class="ti-book"></i>
        </div>
        <div
          class="numbers"
          slot="content"
        >
          {{ edu.speechesCount }}
          <p>Palestras</p>
        </div>
        <!-- <div class="stats" slot="footer"><i :class="stats.footerIcon"></i> {{stats.footerText}}</div> -->
      </stats-card>
    </div>
  </div>
</div>
</template>
<script>
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'count-cards',
  components: {StatsCard},
  props: {
    input: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      eventsEDUCount: null,
      speechesEDUCount: null,
      isLoadingEventsEDUCount: true,
      isLoadingSpeechesEDUCount: true
    }
  },

  computed: {
    projectOnline: () => {
      return process.env.PROJECT_ONLINE
    },
    ...mapGetters({
      edu: 'apiEdu'
    }),

    ...mapGetters('project', {
      config: 'project'
    }),

    ...mapGetters('tags', {
      tags: 'selecteds'
    }),

    ...mapGetters({
      dateRange: 'rangeDate'
    }),

    ...mapGetters('surveys', {
      loadingSurveys: 'loading',
      surveysFinishedCount: 'dashboardCounter'
    }),

    ...mapGetters('events', {
      eventsCount: 'events',
      isLoadingEventsCount: 'loading'
    }),

    ...mapGetters('lamps', {
      lampsCount: 'dashboardCounter',
      isLoadingLampsCount: 'loading'
    }),

    ...mapGetters('tickets', {
      winnersCount: 'winningTickets',
      isLoadingWinnersCount: 'winningLoading',
      ticketsCount: 'dashboardCounter',
      isLoadingTicketsCount: 'loading'
    }),

    ...mapGetters('users', {
      isLoadingCustomersCount: 'loading'
    }),

    ...mapGetters('customers', {
      participantsCount: 'dashboardCounter'
    }),

    inputDate: function () {
      return this.input || null
    }
  },

  mounted () {
    this.fetchTicketsCount()
  },

  methods: {
    ...mapActions('events', ['fetchTicketsCount', 'filterEvents'])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/CountCards.vue